import { render, staticRenderFns } from "./ClearForSterilization.vue?vue&type=template&id=52356e72&"
import script from "./ClearForSterilization.vue?vue&type=script&lang=js&"
export * from "./ClearForSterilization.vue?vue&type=script&lang=js&"
import style0 from "./ClearForSterilization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports